document.addEventListener("DOMContentLoaded", function() {
    $('.announcement-open-search').on('click', function() {
        $(this).closest('.section-announcement__row').addClass('closed');
        $(this).closest('.section-announcement').find('.section-announcement__search-row').addClass('open');

        $(this).closest('.section-announcement')
            .find('.announcement-search-form input[type="search"], .announcement-search-form input[type="search"]')
            .focus();
    });

    $('.announcement-close-search').on('click', function() {
        $(this).closest('.section-announcement').find('.section-announcement__row').removeClass('closed');
        $(this).closest('.section-announcement__search-row').removeClass('open');
    });
});
